import React, { useCallback, useContext, useEffect, useReducer, useRef, useState } from 'react'
import * as landmarksUtils from '../util/LandmarksUtils'
import { LanguageContext } from "../App"
import Nouislider from 'nouislider-react';
import $ from 'jquery'
let interval;

const Animator = ({jsonFile,uploaderChangeCounter,width,height,noFPS,isVideoConnected,connectedVideo}) =>{

    const language = useContext(LanguageContext)
    const [numFrames,setNumFrames] = useState(0)
    const canvas_ref = useRef(null)
    const [canvasWidth,setCanvasWidth]=useState(width)
    const [canvasHeight,setCanvasHeight]=useState(height)
    const [currentFrame,setCurrentFrame] = useState(0)
    const [frameFrequency,setFrameFrequency] = useState(66)
    const [isAnimationActive,setIsAnimationActive] = useState(true)
    const [canvasCtx,setCanvasCtx] = useState({})
    const [toggleBtnClass,setToggleBtnClass] = useState("info")

    useEffect(()=>{
        if (isAnimationActive) {
            if(isVideoConnected){
                connectedVideo.current.pause()
                let curr_time = Number((currentFrame / numFrames) * connectedVideo.current.duration).toFixed(4)
                if (!curr_time || curr_time > connectedVideo.current.currentTime) {curr_time = connectedVideo.current.currentTime}
                try{connectedVideo.current.currentTime=curr_time}
                catch(e){console.log(e.message)}
                //connectedVideo.current.play()
            }
        }
        else{
            if(isVideoConnected){
                connectedVideo.current.pause()
                let curr_time = Number((currentFrame / numFrames) * connectedVideo.current.duration).toFixed(4)
                if (!curr_time || curr_time > connectedVideo.current.currentTime) {curr_time = connectedVideo.current.currentTime}
                try{connectedVideo.current.currentTime=curr_time}
                catch(e){console.log(e.message)}
            }
        }
    },[isAnimationActive])

    const handleSlide = (index) =>{
        setIsAnimationActive(false)
        setCurrentFrame(parseInt(index[0]))
    }

    // Animate landmarks from json file
    const landmarksAnimator = (ctx,curr_frame,num_frames,landmarks) =>{
        ctx = landmarksUtils.drawLandmarks(ctx,landmarks[curr_frame],canvasWidth,canvasHeight)
    }

    const handleAnimationToggleBtn = ()=>{
        setIsAnimationActive(!isAnimationActive)
    }

    const handleFrameFrequencyChange = (fps) =>{
        const freq =  1000/fps
        setFrameFrequency(freq)
    }

    useEffect(()=>{
        let curr_frame = currentFrame
        let slider = $('.noUi-handle')
        let connect_slider = $('.noUi-connect')
        setToggleBtnClass(isAnimationActive? "secondary": "info")
        if(numFrames>0 && isAnimationActive){
            interval = setInterval(() => {
                slider?.attr('aria-valuenow',''+curr_frame)
                slider?.attr('aria-valuetext',''+curr_frame)
                let transform_value = ((numFrames-curr_frame) / numFrames) * (-1000)
                connect_slider?.css("transform","translate(0%,0px) scale("+curr_frame/numFrames+",1)")
                slider?.parent()?.css("transform","translate("+transform_value+"%,0px)")
                canvasCtx.clearRect(0,0,canvasWidth,canvasHeight)
                landmarksAnimator(canvasCtx,curr_frame,numFrames,jsonFile.landmarks,'single')
                if(curr_frame>=numFrames && curr_frame>0) curr_frame=0
                else curr_frame++
                setCurrentFrame(curr_frame)
            }, frameFrequency);

            return () => clearInterval(interval)
        }
    },[numFrames,canvasHeight,canvasWidth,isAnimationActive,frameFrequency])

    useEffect(()=>{
        clearInterval(interval)
    },[uploaderChangeCounter])

    useEffect(()=>{
        let ctx = canvas_ref.current.getContext('2d')
        setCanvasCtx(ctx)
        $('.noUi-connect')?.addClass('bg-info')
        $('.noUi-handle')?.addClass('bg-info')
    },[])

    useEffect(()=>{
        if(numFrames>0){
            canvasCtx.clearRect(0,0,canvasWidth,canvasHeight)
            landmarksAnimator(canvasCtx,currentFrame,numFrames,jsonFile.landmarks)
        }
    },[currentFrame])

    useEffect(()=>{
        if(jsonFile?.landmarks){
            setCurrentFrame(0)
            setIsAnimationActive(true)
            setFrameFrequency(parseInt(jsonFile.frequency))
            setNumFrames(jsonFile?.landmarks?.length - 1)
        }
    },[jsonFile])


    return(
        <div>
            <center>
            <div className="mt-3" id='pld_animator' width={canvasWidth} height={canvasHeight} style={{
                'backgroundColor':'#000000',
                'width':canvasWidth+'px',
                'height': canvasHeight+'px'
                }}>
                <canvas  ref={canvas_ref} id="cam-canvas" width={canvasWidth} height={canvasHeight}></canvas>   
            </div>
            </center>
            <div className='m-auto d-flex' style={{width:'40%'}}>
                <div className='col p-1 align-self-right'>
                    <button className={'mt-2 btn btn-'+ toggleBtnClass} onClick={handleAnimationToggleBtn}>
                        {isAnimationActive? 
                        <i className="fa fa-pause" aria-hidden="true"></i>
                        :
                        <i className="fa fa-play" aria-hidden="true"></i>
                        }
                    </button>
                </div>
                <div className='col-xl-11 col-sm-10 p-3'>
                {
                    (numFrames !=0 && numFrames) ?
                    <Nouislider step={1} range={{ min: 0, max: numFrames}} start={[0]} connect={[true,false]} onUpdate={index=>{handleSlide(index)}} />
                    :
                    <Nouislider range={{ min: 0, max: 1}} start={[0]} connect={[true,false]} onUpdate={index=>{handleSlide(index)}} />
                }
                </div>
                
            </div>
            <p>frame : {currentFrame} / {numFrames ? numFrames:0}</p>
            <br />
            {
            (noFPS)?<></>:
                <div className='p-3 m-2'>
                    <p>
                        {language.animator.frame_rate}
                    </p>
                    {
                        (frameFrequency) ?
                        <input type="number" value={1000/frameFrequency} min="0" max="1000" step="1" onChange={e=>handleFrameFrequencyChange(e.target.value)}/>
                        :
                        <input type="number" value={30} min="0" max="1000" step="1" onChange={e=>handleFrameFrequencyChange(e.target.value)}/>
                    }
                    
                </div>
            }
        </div>
    )
}
export default Animator
